import { useMemo } from "react";
import useUiuxStore from "src/store/useUiuxStore";

export function useWMS1131_R01Modal() {
	const { setCodeSearchModalProps } = useUiuxStore();

	return useMemo(
		() => ({
			setCodeSearchModalProps,
		}),
		[setCodeSearchModalProps],
	);
}
